export default {
	key: 'forms',
	path: '/forms',
	name: 'forms',
	component: () => import(/* webpackChunkName: "forms" */ '@/modules/documentation/pages/forms/index.vue'),
	children: [
		{
			key: 'forms-checkboxes',
			path: 'checkboxes',
			name: 'checkboxes',
			component: () => import(/* webpackChunkName: "checkboxes" */ '@/modules/documentation/pages/forms/checkboxes.vue')
		},
		{
			key: 'forms-controls',
			path: 'controls',
			name: 'controls',
			component: () => import(/* webpackChunkName: "controls" */ '@/modules/documentation/pages/forms/controls.vue')
		},
		{
			key: 'forms-inputs',
			path: 'inputs',
			name: 'inputs',
			component: () => import(/* webpackChunkName: "inputs" */ '@/modules/documentation/pages/forms/inputs.vue')
		},
		{
			key: 'forms-labels',
			path: 'labels',
			name: 'labels',
			component: () => import(/* webpackChunkName: "labels" */ '@/modules/documentation/pages/forms/labels.vue')
		},
		{
			key: 'forms-radios',
			path: 'radios',
			name: 'radios',
			component: () => import(/* webpackChunkName: "radios" */ '@/modules/documentation/pages/forms/radios.vue')
		},
		{
			key: 'forms-selects',
			path: 'selects',
			name: 'selects',
			component: () => import(/* webpackChunkName: "selects" */ '@/modules/documentation/pages/forms/selects.vue')
		},
		{
			key: 'forms-textareas',
			path: 'textareas',
			name: 'textareas',
			component: () => import(/* webpackChunkName: "textareas" */ '@/modules/documentation/pages/forms/textareas.vue')
		},
		{
			key: 'forms-form',
			path: 'form',
			name: 'form',
			component: () => import(/* webpackChunkName: "form" */ '@/modules/documentation/pages/forms/form.vue')
		}
	]
};
